<template>
  <div ref="card" class="card" v-show="show" v-click-outside="closeCard" :style="adjustStyle">
    <div class="title">{{user.username}}</div>
    <div class="content">
      <ul>
        <li>
          <img src="./assets/name.png" alt="">
          <p>{{user.truename}}</p>
        </li>
        <li>
          <img src="./assets/phone.png" alt="">
          <p>{{user.phone}}</p>
        </li>
        <li>
          <img src="./assets/mail.png" alt="">
          <p>{{user.email}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import vClickOutside from 'v-click-outside'

export default {
  name: 'card',
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      show: true,
      user: {

      },
      defaultAvatar: require('@assets/img/common/defaultAvatar.png'),
      content: {
        avatar: require('@assets/img/common/defaultAvatar.png'),
        name: '',
        tel: '',
        mail: ''
      },
      adjustStyle: {}
    }
  },
  methods: {
    closeCard() {
      this.content = {
        avatar: this.defaultAvatar,
        name: '',
        tel: '',
        mail: ''
      }

      this.close()
    },
    open(id, type=0) {
      this.user = id
      this.show = true
      console.log(9999)
    },
    adjustPosition() {
      // 根据视图调整窗口位置,使其能够出现在窗口内
      const cardElementRect = this.$refs.card.getBoundingClientRect()
      const elementBottom = cardElementRect.top + cardElementRect.height
      const elementRight = cardElementRect.left + cardElementRect.width
      const windowHeight = window.innerHeight
      const windowWidth = window.innerWidth
      const gap = 20
      let mright = 0
      let mbottom = 0
      if (elementBottom >= windowHeight - 20) {
        mbottom = elementBottom - windowHeight + gap
      }

      if (elementRight >= windowWidth - 20) {
        mright = elementRight - windowWidth + gap
      }

      const adjustStyle = {
        transform: `translate(-${mright}px, -${mbottom}px)`
      }

      this.adjustStyle = adjustStyle
    },
    getUserCard(id, type) {
      // 获取用户卡片数据
      const info = {
        user_id: id,
        type: type
      }
      const obj = {
        data: info,
        hideLoading: true
      }

      return common.myFetch(apis.Usr_card, obj)
      .then((r) => {
        if (r) {
          const content = {
            avatar: r.avatar || this.defaultAvatar,
            name: r.truename || '无',
            tel: r.phone || '无',
            mail: r.email || '无',
            project_title: r.project_title || '无'
          }

          this.content = content
        }

        return r
      })
    },
    close() {
      this.show = false
    }
  },
  mounted() {
    this.defaultAvatar = this.$_syscfg.default_avatar
    this.content.avatar = this.$_syscfg.default_avatar
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .card {
    width: 245px;
    height: 190px;
    position: absolute;
    top: 40px;
    left: 40px;
    border-radius: 4px;
    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
    overflow: hidden;
    background-color: rgba(5, 15, 15, .8);
    z-index: 999;
    border-radius: 4px;
    
    .title {
      width: 100%;
      height: 45px;
      font-size: 18px;
      line-height: 45px;
      font-weight: bold;
      color: #FFFFFF;
      padding: 0 25px;
      box-sizing: border-box;
    }

    .content {
      width: 245px;
      height: 145px;
      background: rgba(5, 15, 15, 0.75);
      box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
      padding: 13px 25px 0;
      box-sizing: border-box;

      ul {
        display: flex;
        flex-direction: column;

        li {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-bottom: 16px;

          img {
            width: 27px;
            height: 27px;
            margin-right: 14px;
          }

          p {
            font-size: 14px;
            line-height: 20px;
            color: #FFFFFF;
            font-weight: bold;
          }
        }
      }
    }
  }
</style>
